/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./save-demand.vue?vue&type=template&id=53899f1a&scoped=true&"
import script from "./save-demand.vue?vue&type=script&lang=js&"
export * from "./save-demand.vue?vue&type=script&lang=js&"
import style0 from "./save-demand.vue?vue&type=style&index=0&id=53899f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53899f1a",
  null
  
)

export default component.exports